import { Slice, createSlice, EnhancedStore, configureStore } from "@reduxjs/toolkit";
import { AppState, StoreReducerAction } from "../types/appTypes";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";

const slice: Slice = createSlice({
	name: "dataSlice",
	initialState: {
		integrationApiUrl: process.env.REACT_APP_INTEGRATION_URL,
		kanbanizeDomain: undefined,
		currentlyEditingRepoName: undefined,
		userToken: undefined,
		currentConfig: undefined,
		generalError: false,
	} as AppState,
	reducers: {
		updateDomain: (state: AppState, action: StoreReducerAction) => (state.kanbanizeDomain = action.payload),
		updateCurrentRepoName: (state: AppState, action: StoreReducerAction) => (state.currentlyEditingRepoName = action.payload),
		updateUserToken: (state: AppState, action: StoreReducerAction) => (state.userToken = action.payload),
		updateCurrentConfig: (state: AppState, action: StoreReducerAction) => (state.currentConfig = action.payload),
		updateGeneralError: (state: AppState, action: StoreReducerAction) => (state.generalError = action.payload),
	},
});

const persistConfig = {
	key: "root",
	storage,
};

const persistedReducer = persistReducer(persistConfig, slice.reducer);

const store: EnhancedStore = configureStore({
	reducer: persistedReducer,
});

const persistor = persistStore(store);

const { updateDomain, updateCurrentRepoName, updateUserToken, updateCurrentConfig } = slice.actions;

export { store, persistor, updateDomain, updateCurrentRepoName, updateUserToken, updateCurrentConfig };
